import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef } from "react";

/**
 * MessageBox - a simple wrapper around Chakra UI AlertDialog
 *
 * Props:
 * - isOpen: boolean
 * - onClose: function
 * - onConfirm: function
 * - title: string
 * - description: string or ReactNode
 * - confirmText: string (default: "Confirm")
 * - cancelText: string (default: "Cancel")
 * - isLoading: boolean (disables confirm button and shows spinner)
 * - colorScheme: string (for confirm button, default: "red")
 */
export default function MessageBoxButton({
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  colorScheme = "red",
  buttonText = "Open Message Box",
  buttonProps = {},
  onClick,
}) {
  const cancelRef = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = () => {
    onOpen();
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleClick}>
        {buttonText}
      </Button>
      <AlertDialog isOpen={!!isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {title}
            </AlertDialogHeader>

            <AlertDialogBody>
              {typeof description === "string" ? <Text>{description}</Text> : description}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} mr={3}>
                {cancelText}
              </Button>
              <Button
                colorScheme={colorScheme}
                onClick={() => {
                  onClose();
                  onConfirm();
                }}
                isLoading={isLoading}
              >
                {confirmText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
